const dev = process.env.NODE_ENV !== 'production';

/**
 * Get environment variables based on current environment
 * Returns an object with all required environment variables
 */
export default function environmentVariables() {
    return {
        REACT_APP_API_URL: process.env.REACT_APP_API_URL || 'http://localhost:4200/api/v1',
        REACT_APP_PAYPAL_CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
        REACT_SECURE_LOCAL_STORAGE_HASH_KEY: process.env.REACT_SECURE_LOCAL_STORAGE_HASH_KEY || 'dhfgdfgyigfyo348',
        REACT_SECURE_LOCAL_STORAGE_PREFIX: process.env.REACT_SECURE_LOCAL_STORAGE_PREFIX || 'sdjyfgdyfgs',
        PORT: process.env.PORT || 3000,
        SKIP_PREFLIGHT_CHECK: process.env.SKIP_PREFLIGHT_CHECK === 'true',
        isDev: dev
    };
}